import styled from "@xstyled/styled-components";

import { Founder } from "../../types";

import { Text } from "@otta/design";
import { pxToRem } from "@otta/design-tokens";
import { Link } from "@hire/components/links/Link";

const StyledLink = styled(Link)`
  text-decoration: underline;
  font-weight: normal;
  color: black;
  :hover {
    text-decoration: none;
    
`;

export const FounderPreview = (props: Founder) => {
  const { name, linkedinUrl, bio, title } = props;
  return (
    <>
      <Text bold>
        {name} ({title})
      </Text>
      <Text style={{ margin: `${pxToRem(8)} 0` }}>{bio}</Text>
      {linkedinUrl && (
        <Text>
          <StyledLink newTab to={linkedinUrl}>
            {linkedinUrl}
          </StyledLink>
        </Text>
      )}
    </>
  );
};
